import { Box } from '@material-ui/core';
import classNames from 'classnames';
import { SGSForm, SGSRadioCtr } from 'components';
import SGSInputCurrency from 'components/SGSCurrency';
import { CodeCerfa } from 'features/arretTravail/models/scenarii';
import { WorkedHours, workedHoursS3202200ptions, workedHoursS3202800Options } from 'features/arretTravail/models/StopInformation/workStoppage';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '../../../../css/ArretTravail.module.scss';

type RightsS3202SectionProps = {
    store: any;
};

const RightsS3202Section: React.FC<RightsS3202SectionProps> = ({ store }) => {
    const { watch, setValue } = useFormContext();
    const displayLegendRightsCase = store.cerfa === CodeCerfa.S3202;

    const watchWorkedHous1 = watch('workStoppage.rightsS3202.workedHours1');
    const watchWorkedHous2 = watch('workStoppage.rightsS3202.workedHours2');

    const diseableCotisations = !watchWorkedHous1 && !watchWorkedHous2 ? true : watchWorkedHous1 === WorkedHours.Minus800 || watchWorkedHous2 === WorkedHours.Minus200 ? false : true;

    useEffect(() => {
        if (diseableCotisations) {
            setValue('workStoppage.rightsS3202.contribution1', null);
            setValue('workStoppage.rightsS3202.contribution2', null);
            delete store?.workStoppage?.rightsS3202?.contribution1;
            delete store?.workStoppage?.rightsS3202?.contribution2;
        }
    }, [diseableCotisations]);

    if (!displayLegendRightsCase) {
        delete store?.workStoppage?.rightsS3202?.workedHours1;
        delete store?.workStoppage?.rightsS3202?.workedHours2;
        return null;
    }

    return (
        <>
            <Box className={classNames(styles.title, 'mb-4')}>Heures travaillées</Box>
            <SGSForm.Row>
                <SGSForm.Col md={7}>le nombre d'heures de travail salarié ou assimilé au cours des 12 mois civils ou des 365 jours précédant la date d'interruption de travail.</SGSForm.Col>
                <SGSForm.Col md={5}>
                    <SGSRadioCtr row options={workedHoursS3202800Options} name="workStoppage.rightsS3202.workedHours1" />
                </SGSForm.Col>
            </SGSForm.Row>
            <SGSForm.Row>
                <SGSForm.Col md={7}>et le nombre d'heures de travail salarié ou assimilé au cours des 3 premiers mois de la période considérée.</SGSForm.Col>
                <SGSForm.Col md={5}>
                    <SGSRadioCtr row options={workedHoursS3202200ptions} name="workStoppage.rightsS3202.workedHours2" />
                </SGSForm.Col>
            </SGSForm.Row>
            <SGSForm.Row>
                <SGSForm.Col md={7}>
                    le montant des cotisations versées au titre des assurances maladie, maternité, invalidité, décès assises sur les rémunérations perçues par le(la) salarié(e) au cours des 12 mois
                    civils précédant la date d’interruption de travail
                </SGSForm.Col>
                <SGSForm.Col md={5}>
                    <SGSInputCurrency variant="outlined" name="workStoppage.rightsS3202.contribution1" disabled={diseableCotisations} />
                </SGSForm.Col>
            </SGSForm.Row>
            <SGSForm.Row>
                <SGSForm.Col md={7}>
                    et le montant des cotisations versées au titre des assurances maladie, maternité, invalidité, décès assises sur les rémunérations perçues par le(la) salarié(e) au cours des 6
                    premiers mois de cette même période
                </SGSForm.Col>
                <SGSForm.Col md={5}>
                    <SGSInputCurrency variant="outlined" name="workStoppage.rightsS3202.contribution2" disabled={diseableCotisations} />
                </SGSForm.Col>
            </SGSForm.Row>
        </>
    );
};

export default RightsS3202Section;
